import { render, staticRenderFns } from "./FacetSelect.vue?vue&type=template&id=2889611a&scoped=true&"
import script from "./FacetSelect.vue?vue&type=script&lang=js&"
export * from "./FacetSelect.vue?vue&type=script&lang=js&"
import style0 from "./FacetSelect.vue?vue&type=style&index=0&id=2889611a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889611a",
  null
  
)

component.options.__file = "FacetSelect.vue"
export default component.exports